<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Scan-Läufe</h1>

    @if (binding) {
      <p class="text-muted mt-2">
        {{ customerName }} &mdash; {{ binding.providerKey }} &mdash; {{ binding.rootUrl }}
      </p>
    }

    <kendo-grid class="mt-3" [data]="runs" [resizable]="true">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="loading" loadingText="Läufe werden geladen…" i18n-loadingText emptyText="Keine Scan-Läufe vorhanden" i18n-emptyText></app-grid-no-records>
      </ng-template>

      <ng-template kendoGridToolbarTemplate>
        <button class="btn btn-secondary ms-auto" type="button" (click)="refresh()" i18n>
          Aktualisieren
        </button>
      </ng-template>

      <kendo-grid-column field="startedAt" i18n-title title="Start" format="{0:g}" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="finishedAt" i18n-title title="Ende" format="{0:g}" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="status" i18n-title title="Status" [width]="140">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="badge" [ngClass]="statusClass(dataItem.status)">{{ statusName(dataItem.status) }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="itemsDiscovered" i18n-title title="Gefunden" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="itemsCreated" i18n-title title="Neu" [width]="90"></kendo-grid-column>
      <kendo-grid-column field="itemsUpdated" i18n-title title="Aktualisiert" [width]="110"></kendo-grid-column>
      <kendo-grid-column field="itemsSkipped" i18n-title title="Übersprungen" [width]="120"></kendo-grid-column>
      <kendo-grid-column field="itemsErrored" i18n-title title="Fehler" [width]="90"></kendo-grid-column>
      <!-- Catalog publish activity (backend #503 A5): what actually reached the catalog,
           vs. the scan-ledger counters left of here. A gap between the two (e.g.
           Aktualisiert = 12 but Listing aktualisiert = 9) flags publishes that didn't
           land — missing price, non-EUR, delisted rows, Catalog errors. -->
      <kendo-grid-column field="itemsListed" i18n-title title="Gelistet" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="itemsListingUpdated" i18n-title title="Listing aktualisiert" [width]="140"></kendo-grid-column>
      <kendo-grid-column field="errorMessage" i18n-title title="Fehlermeldung"></kendo-grid-column>
    </kendo-grid>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button class="btn btn-secondary" type="button" (click)="onBackClicked()" i18n>
        Zurück
      </button>
    </div>
  </div>
</div>
